export default "__VITE_ASSET__0a1c9f40__"